import businessClient from 'src/services/clients/business'

import { IMeta, IPosSalesItem, ISalesItemView } from 'src/common/interfaces/index.js'

const IApppairListResponse = { meta: IMeta, data: { list: [1], full_list: [{ partner_id: 1, partner_name: '' }] } }
const IResendPosResponse = {
  meta: IMeta,
  data: { insertedSaleMaster: ISalesItemView, insertedSaleItems: [IPosSalesItem] },
}

export const apppair = {
  /**
   * @param {{reporting_partners?: boolean}} filter
   * @param {signal?: AbortSignal} signal
   * @return {Promise<IApppairListResponse>}
   */
  pairedPartners(filter = undefined, signal = undefined) {
    return businessClient().post('apppair/paired-partners', { filter }, { signal })
  },

  /**
   * @param {object}data0
   * @return {Promise<IApppairListResponse>}
   */
  requestIntegration(data, signal) {
    return businessClient().post('apppair/request-integration', { data }, { signal })
  },

  /**
   * @param {{ partner_id: number }} filter
   * @return {Promise<IResponse>}
   */
  list(filter, signal) {
    return businessClient().post('apppair/partner-data', { filter }, { signal })
  },

  /**
   * @param {{order_id: number}} data
   * @return {Promise<IResendPosResponse>}
   */
  resendPos(data, signal) {
    return businessClient().post('apppair/resend-pos', { data }, { signal })
  },
}
